import fiAdmin from "./locales/fi/admin.json";
import enAdmin from "./locales/en/admin.json";
import fiCommon from "./locales/fi/common.json";
import enCommon from "./locales/en/common.json";

export const DEFAULT_LANGUAGE = "fi";
export const LANGUAGE_STORAGE_KEY = "paranoidi_ui_language";

/**
 * Kaikki käyttöliittymäkielet määritellään tässä yhdessä paikassa.
 * Uusi kieli: lisää sen käännöstiedostot, importit ja yksi tietue tähän listaan.
 * Biisien kielitagit ja esiintyjän omat tekstit eivät kuulu tähän rakenteeseen.
 */
export const UI_LANGUAGES = [
  {
    code: "fi",
    nativeName: "Suomi",
    locale: "fi-FI",
    direction: "ltr",
    resources: { common: fiCommon, admin: fiAdmin },
  },
  {
    code: "en",
    nativeName: "English",
    locale: "en-GB",
    direction: "ltr",
    resources: { common: enCommon, admin: enAdmin },
  },
];

// Tunnistetaan myös esimerkiksi en-GB. Tuntematonta kieltä ei oteta käyttöön.
export function normalizeUiLanguage(value) {
  if (typeof value !== "string") {
    return null;
  }

  const normalized = value.trim().toLowerCase().replace(/_/g, "-");
  const exactMatch = UI_LANGUAGES.find((item) => item.code === normalized);
  const baseMatch = UI_LANGUAGES.find(
    (item) => item.code === normalized.split("-")[0]
  );

  return exactMatch?.code || baseMatch?.code || null;
}

export function getUiLanguage(value) {
  const code = normalizeUiLanguage(value) || DEFAULT_LANGUAGE;
  return UI_LANGUAGES.find((item) => item.code === code);
}

export function detectBrowserUiLanguage() {
  if (typeof navigator === "undefined") {
    return DEFAULT_LANGUAGE;
  }

  const browserLanguage = String(
    navigator.languages?.[0] || navigator.language || ""
  )
    .trim()
    .toLowerCase()
    .replace(/_/g, "-");

  if (!browserLanguage) {
    return DEFAULT_LANGUAGE;
  }

  // Suomi -> FI. Kaikki muut selaimen kielet -> EN.
  return browserLanguage.split("-")[0] === "fi" ? "fi" : "en";
}

export function readSavedUiLanguage() {
  try {
    if (typeof window !== "undefined") {
      const savedLanguage = normalizeUiLanguage(
        window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
      );

      if (savedLanguage) {
        return savedLanguage;
      }
    }
  } catch {
    // Selaimen tallennustilan esto ei saa estää sovelluksen käynnistymistä.
  }

  return detectBrowserUiLanguage();
}

export function saveUiLanguage(value) {
  const code = normalizeUiLanguage(value);

  if (!code) {
    return;
  }

  try {
    if (
      typeof window !== "undefined" &&
      window.localStorage.getItem(LANGUAGE_STORAGE_KEY) !== code
    ) {
      window.localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
    }
  } catch {
    // Valinta toimii silti nykyisellä sivulla, vaikka sitä ei voisi muistaa.
  }
}